import React, {
  Fragment,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from 'react';
import { useTranslation } from 'react-i18next';

import { useSelector, useDispatch } from 'react-redux';

import { VariableActions } from '../../../store/actions/variables';

import AceEditor from 'react-ace';
import './styles.scss';
import { set, findIndex } from 'lodash';
import Select from '../../Select';

import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-kuroir';
import 'ace-builds/src-noconflict/theme-monokai';

import iconAdd from '../../../assets/images/icon_add_blue.svg';
import iconDelete from '../../../assets/images/icon_delete_custom.svg';
import MenuVariaveis from '../../MenuVariaveis';

export default (props) => {
  const {
    answerHandlerOpen,
    toggleAnswerHandler,
    editItem,
    item,
    variable,
    onVariableUpdate,
    match,
    doUpdateItem,
  } = props;

  const { variables: variablesState } = useSelector(
    (state) => state.variables.variablesState
  );

  const { i18n } = useTranslation();

  const dispatch = useDispatch();
  const { botid: botId } = match.params;

  const [methodDropdownOpen, setMethodDropdownOpen] = useState(false);
  const [urlEndpoint, setUrlEndpoint] = useState(item.urlEndpoint || '');
  const [jsonPayload, setJsonPayload] = useState(item.jsonPayload || '');
  const [httpHeaders, setHttpHeaders] = useState(item.headers || []);
  const [waitResponse, setWaitResponse] = useState(item.waitResponse);
  const [timeout, setTimeout] = useState(item.timeout || 10000);
  const [variables, setVariables] = useState(item.apiV2Variables || []);

  item.methodType = item.methodType ? item.methodType : 'GET';

  useEffect(() => {
    if (item.apiV2Variables === undefined) {
      setVariables([]);
    } else {
      setVariables(item.apiV2Variables);
    }
  }, [item.apiV2Variables]);

  useEffect(() => {
    setMethodDropdownOpen(false);
    setUrlEndpoint(item.urlEndpoint || '');
    setJsonPayload(item.jsonPayload || '');
    setHttpHeaders(item.headers || []);
    setWaitResponse(item.waitResponse);
    setTimeout(item.timeout || 10000);
  }, [item]);

  const toggleMethodDropdown = () => {
    setMethodDropdownOpen(!methodDropdownOpen);
  };

  const updateMethodType = (type) => {
    toggleMethodDropdown();
    item.methodType = type;
    doUpdateItem({ methodType: type });
  };

  const updateWaitResponse = (value) => {
    setWaitResponse(value);
    doUpdateItem({ waitResponse: value });
  };

  const updateJsonPayload = (value) => {
    setJsonPayload(value);
    doUpdateItem({ jsonPayload: value });
  };

  const onInputChanged = (e, state) => {
    const { name, value } = e.target;
    state(value);
    const payload = {};
    payload[name] = value;
    doUpdateItem(payload);
  };

  const handleSelectVariavel = (name, value, variavel, setState) => {
    const newValue = `${value} ${variavel}`;

    setState(newValue);
    doUpdateItem({ [name]: newValue });
  };

  const handleSelectVariavelHeaderValue = (value, variavel, index) => {
    httpHeaders[index].value = `${value} ${variavel}`;
    setHttpHeaders(httpHeaders);
    doUpdateItem({ headers: httpHeaders });
  };

  const handleAddHeader = () => {
    const valor = { key: '', value: '' };
    setHttpHeaders(httpHeaders.concat(valor));
  };

  const changeHeaderKey = (index, e) => {
    httpHeaders[index].key = e.target.value;
    setHttpHeaders(httpHeaders);
    doUpdateItem({ headers: httpHeaders });
  };

  const changeHeaderValue = (index, e) => {
    httpHeaders[index].value = e.target.value;
    setHttpHeaders(httpHeaders);
    doUpdateItem({ headers: httpHeaders });
  };

  const deleteHeader = (item) => {
    // setHttpHeaders(httpHeaders.filter((element) => element !== item))
    const findIndexItem = httpHeaders.findIndex((header) => header === item);
    const newArray = httpHeaders.splice(findIndexItem, 1);
    setHttpHeaders(newArray);

    doUpdateItem({ headers: httpHeaders });
  };

  // VARIAVEL
  const handleAddVar = async () => {
    const valor = { key: '', value: '' };
    setVariables(variables.concat(valor));
  };

  const changeVarValue = (index, e) => {
    variables[index].value = e.target.value;
    setVariables(variables);
    doUpdateItem({ apiV2Variables: variables });
  };

  const deleteVar = (item) => {
    const findIndexItem = variables.filter((header) => header !== item);
    setVariables(findIndexItem);
    doUpdateItem({ apiV2Variables: findIndexItem });
  };

  const formattedVariableOptions = useMemo(() => {
    return variablesState && variablesState.bot
      ? variablesState.bot.map((_variable) => ({
          value: _variable.name,
          label: _variable.name,
        }))
      : [];
  }, [variablesState]);

  const selectedVariableToSelect = (index) => {
    const selectObject = {
      value: variables[index].key,
      label: variables[index].key,
    };
    return selectObject;
  };

  const handleChangeVariable = (index, arrayWithNewValue) => {
    const newVariable = !arrayWithNewValue
      ? { value: '', label: '' }
      : arrayWithNewValue;

    variables[index].key = newVariable.value;
    setVariables(variables);
    doUpdateItem({ apiV2Variables: variables });
    onVariableUpdate(newVariable.value);
  };

  const handleCreateVariableOption = (index, inputValue) => {
    const payload = {
      botId,
      type: 'user',
      active: true,
      name: inputValue,
      value: '',
    };
    variables[index].key = inputValue;
    setVariables(variables);
    doUpdateItem({ apiV2Variables: variables });
    dispatch(VariableActions.create(payload));
    onVariableUpdate(inputValue);
  };

  return (
    <Fragment>
      <p className="pointer handler-title" onClick={toggleAnswerHandler}>
        {i18n.t('JSON API')}{' '}
        <img
          alt=""
          className={`seta-expander ${
            !answerHandlerOpen ? 'arrow-rotation' : ''
          }`}
          src="/assets/images/icons/seta_close.svg"
        />
      </p>

      {/* URL ENDPOINT */}
      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel(
            'urlEndpoint',
            urlEndpoint,
            `{${variavel}}`,
            setUrlEndpoint
          )
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-urlEndpoint`}
        isTooltip
        hidden={!answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('URL')}</label>
          <input
            type="url"
            placeholder="https://url.com/endpoint"
            id="api-urlEndpoint"
            name="urlEndpoint"
            className="form-control mt-1"
            value={urlEndpoint}
            onChange={(e) => onInputChanged(e, setUrlEndpoint)}
          />
        </div>
      </MenuVariaveis>

      {/* HTTP METHOD */}
      <div
        className="form-group validation-input-group destination-input-group mb-1"
        hidden={!answerHandlerOpen}
      >
        <label>{i18n.t('Método HTTP')}</label>
        <input
          type="text"
          disabled
          className="form-control outline-none input-control mt-1"
          value={item.methodType || ''}
        />
        <i className="arrow down" />
        <button onClick={toggleMethodDropdown} />
        <div className="validation-dropdown" hidden={!methodDropdownOpen}>
          {/* GET */}
          <div
            className="validation-dropdown-line"
            onClick={() => updateMethodType('GET')}
          >
            <span>GET</span>
            <i className="arrow down" hidden={item.methodType !== 'GET'} />
          </div>
          {/* POST */}
          <div
            className="validation-dropdown-line"
            onClick={() => updateMethodType('POST')}
          >
            <span>POST</span>
            <i className="arrow down" hidden={item.methodType !== 'POST'} />
          </div>
          {/* PUT */}
          <div
            className="validation-dropdown-line"
            onClick={() => updateMethodType('PUT')}
          >
            <span>PUT</span>
            <i className="arrow down" hidden={item.methodType !== 'PUT'} />
          </div>
          {/* DELETE */}
          <div
            className="validation-dropdown-line"
            onClick={() => updateMethodType('DELETE')}
          >
            <span>DELETE</span>
            <i className="arrow down" hidden={item.methodType !== 'DELETE'} />
          </div>
        </div>
      </div>

      {/* { HTTP Header Customizado} */}
      <div className="header-customizado-api">
        <div className="header-title-customizado">
          <label>{i18n.t('Adicionar header customizado')}</label>
          <img src={iconAdd} alt="" onClick={handleAddHeader} />
        </div>
        {httpHeaders.map((header, index) => (
          <div className="header-added-value">
            <div className="common-form-group">
              <label>{i18n.t('Chave')}</label>
              <input
                type="text"
                id="header-key"
                name="headerKey"
                className="form-control col-md-11 mt-1"
                value={header.key}
                onChange={(e) => changeHeaderKey(index, e)}
              />
            </div>

            <MenuVariaveis
              onSelect={(variavel) =>
                handleSelectVariavelHeaderValue(
                  header.value,
                  `$$${variavel}$$`,
                  index,
                  'headerValue',
                  setHttpHeaders
                )
              }
              buttonRight="35px"
              buttonBottom="25px"
              id={`bloco-${item._id}-configuracao-header-${header.key}`}
              isTooltip
              hidden={!answerHandlerOpen}
            >
              <div className="common-form-group">
                <label>{i18n.t('Valor')}</label>

                <input
                  type="text"
                  id="header-value"
                  name="headerValue"
                  className="form-control col-md-11 mt-1"
                  value={header.value}
                  onChange={(e) => changeHeaderValue(index, e)}
                />
              </div>
            </MenuVariaveis>
            <img
              src={iconDelete}
              alt=""
              className="img-header-custom"
              onClick={() => deleteHeader(header)}
            />
          </div>
        ))}
      </div>

      {/* Body */}
      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel(
            'jsonPayload',
            jsonPayload,
            `$$${variavel}$$`,
            setJsonPayload
          )
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-jsonPayload`}
        isTooltip
        hidden={!answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Body')}</label>
          <img
            className="right-button"
            src={require('../../../assets/images/expandir.svg')}
            data-toggle="modal"
            data-target="#modal-code-editor"
            alt=""
          />
          <textarea
            className="form-control mt-1"
            value={jsonPayload}
            id="api-jsonpayload"
            name="jsonPayload"
            onChange={(e) => onInputChanged(e, setJsonPayload)}
          />
        </div>
      </MenuVariaveis>

      {/* {Atualização de variáveis} */}
      <div className="header-customizado-api mt-2">
        <div className="header-title-customizado">
          <label>{i18n.t('Atualização de variáveis')}</label>
          <img src={iconAdd} alt="" onClick={handleAddVar} />
        </div>
        {variables.map((updateVar, index) => (
          <div className="header-added-value">
            <div className="common-form-group" hidden={!answerHandlerOpen}>
              <label>{i18n.t('Variável')}</label>
              <div hidden={!answerHandlerOpen}>
                <Select
                  options={formattedVariableOptions}
                  value={selectedVariableToSelect(index)}
                  onChange={(value) => handleChangeVariable(index, value)}
                  onCreateOption={(value) =>
                    handleCreateVariableOption(index, value)
                  }
                  isCreatable
                />
              </div>
            </div>
            <div className="common-form-group">
              <label>{i18n.t('Valor')}</label>
              <input
                type="url"
                id="api-urlEndpoint"
                name="urlEndpoint"
                className="form-control mt-1"
                value={updateVar.value}
                onChange={(e) => changeVarValue(index, e)}
              />
            </div>
            <img
              src={iconDelete}
              alt=""
              className="img-header-custom"
              onClick={() => deleteVar(updateVar)}
            />
          </div>
        ))}
      </div>

      {/* Response Attributes */}
      {/* Aguardar retorno */}
      <div className="form-group row mb-1">
        <div className="custom-control custom-switch mt-2">
          <input
            type="checkbox"
            className="custom-control-input"
            name="waitResponse"
            id="api-waitResponse"
            checked={waitResponse}
            value={waitResponse}
            disabled={props.item && props.item.type === 'Menu'}
            onChange={() => updateWaitResponse(!waitResponse)}
          />
          <label className="custom-control-label" htmlFor="api-waitResponse">
            Aguardar resposta da API
          </label>
        </div>
      </div>

      <div className="common-form-group" hidden={!waitResponse}>
        <label>{i18n.t('timeout')}</label>
        <div className="container-inp-timeout">
          <input
            type="number"
            id="error-maxtries"
            name="timeout"
            className="form-control col-md-5 mt-1"
            value={timeout || ''}
            onChange={(e) => onInputChanged(e, setTimeout)}
          />
          <label>{i18n.t('milissegundos')}</label>
        </div>
      </div>

      {/* MODAL RESPONSE FORMAT */}
      <div
        className="modal fade"
        id="modal-response-format"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content ">
            <div className="modal-header">
              <h5 className="modal-title">
                {i18n.t('Configuraçoes de retorno')}
              </h5>
              <br />
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="response-title-editor-ace">
                {i18n.t('Use esta resposta para mandar mensagens de texto')}
              </div>
              <div className="response-editor">
                <AceEditor
                  placeholder=""
                  mode="javascript"
                  theme="kuroir"
                  name="response-format"
                  disabled
                  onChange={() => {}}
                  className="response-editor-ace"
                  fontSize={12}
                  showPrintMargin
                  showGutter={false}
                  highlightActiveLine={false}
                  readOnly
                  value={`
                  {
                    "messages": [
                      "aaaaaaaaaaa",
                      "bbbbb bbbbb"
                    ]
                  }`}
                  setOptions={{
                    enableBasicAutocompletion: false,
                    enableLiveAutocompletion: false,
                    enableSnippets: false,
                    showLineNumbers: false,
                    tabSize: 2,
                  }}
                />
              </div>
              <div className="response-title-editor-ace">
                {i18n.t('Use esta resposta para atualizar variaveis do Bot')}
              </div>
              <div className="response-editor">
                <AceEditor
                  placeholder=""
                  mode="javascript"
                  theme="kuroir"
                  name="response-format"
                  disabled
                  onChange={() => {}}
                  className="response-editor-ace"
                  fontSize={12}
                  showPrintMargin
                  showGutter={false}
                  highlightActiveLine={false}
                  readOnly
                  value={`
                  {
                    "updateVariables": [
                      {"nmClient": "aaaaa aaaaaa"},
                      {"nuTelephone": "(xx) xxxx xxxx"}
                    ]
                  }`}
                  setOptions={{
                    enableBasicAutocompletion: false,
                    enableLiveAutocompletion: false,
                    enableSnippets: false,
                    showLineNumbers: false,
                    tabSize: 2,
                  }}
                />
              </div>
              <div className="response-title-editor-ace">
                {i18n.t('Podem ser combinados os dois modelos')}
              </div>
              <div className="response-editor">
                <AceEditor
                  placeholder=""
                  mode="javascript"
                  theme="kuroir"
                  name="response-format"
                  disabled
                  onChange={() => {}}
                  className="response-editor-ace"
                  fontSize={12}
                  showPrintMargin
                  showGutter={false}
                  highlightActiveLine={false}
                  readOnly
                  value={`
                  {
                    "messages": [
                      "aaaaaaaaaaa",
                      "bbbbb bbbbb"
                    ],
                    "updateVariables": [
                      {"nmClient": "aaaaa aaaaaa"},
                      {"nuTelephone": "(xx) xxxx xxxx"}
                    ]
                  }`}
                  setOptions={{
                    enableBasicAutocompletion: false,
                    enableLiveAutocompletion: false,
                    enableSnippets: false,
                    showLineNumbers: false,
                    tabSize: 2,
                  }}
                />
              </div>
            </div>
            {/* <div className="modal-footer"> */}
            {/*  <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button> */}
            {/*  <button type="button" className="btn btn-primary">Save changes</button> */}
            {/* </div> */}
          </div>
        </div>
      </div>

      {/* CODE EDITOR */}
      <div
        className="modal fade"
        id="modal-code-editor"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered ajust-centered-mod"
          role="document"
        >
          <div className="modal-content ajust-modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{i18n.t('JSON Payload')}</h5>
              <br />
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <AceEditor
                placeholder=""
                mode="javascript"
                theme="monokai"
                name="jsonPayload"
                id="api-code-editor"
                className="response-editor-ace code-editor mt-2"
                onChange={(value) => updateJsonPayload(value)}
                fontSize={12}
                showPrintMargin
                showGutter
                highlightActiveLine={false}
                value={jsonPayload}
                setOptions={{
                  enableBasicAutocompletion: false,
                  enableLiveAutocompletion: false,
                  enableSnippets: false,
                  showLineNumbers: true,
                  tabSize: 2,
                }}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
              >
                {i18n.t('salvar')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
